/**
 * #18746 — one-click entry to the clinic's messaging console on Addy Message.
 *
 * The URL is minted per request and is single-use with a 60-second life at the platform, so it is
 * never cached and never stored: fetch it at the moment the user asks to go.
 */
import { apiClient } from "./client";

/**
 * `READY` carries a url. The others explain themselves to the clinic instead of leaving the front
 * end to guess from a missing url — "not connected yet" and "connected but broken" need different
 * words, and neither should be discovered by arriving at Addy Message and finding no clinic there.
 */
export interface MessagingConsoleLink {
  state: "READY" | "NOT_PROVISIONED" | "NOT_CONFIGURED" | "FAILED" | "SUSPENDED";
  url: string | null;
}

export const messagingApi = {
  /** `next` (#19667): a console path such as `/app/sms` to land on instead of the dashboard. */
  ssoUrl(next?: string): Promise<MessagingConsoleLink> {
    return apiClient
      .get<MessagingConsoleLink>("/v1/messaging/sso-url", {
        params: next ? { next } : undefined,
      })
      .then((r) => r.data);
  },
};

export const messagingQueryKeys = {
  ssoUrl: () => ["messaging", "sso-url"] as const,
};
